<template>
  <div>
    <v-card>
      <v-card-subtitle>
        <p>ここでは指定する形式のCSVでインポートすることで排出事業場情報を一括登録することができます。</p>
        <p>
          現在登録されている排出事業場情報は
          <v-btn
            color="error"
            class="px-0"
            text
            style="min-width: 0;height: auto;vertical-align: text-bottom"
            @click="downloadButtonClickEvent"
          >
            こちら
          </v-btn>
          からダウンロードできます。
        </p>
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
          >
            <v-card flat>
              <v-card-title>排出事業場情報のインポート</v-card-title>
              <v-divider />
              <v-card-text>
                <validation-observer v-slot="{ invalid }">
                  <v-form>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|mimes:text/csv"
                      name="CSVファイル"
                      class="requiredMark"
                    >
                      <v-file-input
                        v-model="file"
                        :show-size="1000"
                        :error-messages="errors"
                        dense
                        label="CSVファイル"
                        outlined
                        required
                        accept="text/csv"
                        persistent-placeholder
                      />
                    </validation-provider>
                    <div class="text-right">
                      <v-btn
                        color="primary"
                        :disabled="invalid"
                        @click="uploadButtonClickEvent"
                      >
                        アップロード
                      </v-btn>
                    </div>
                  </v-form>
                </validation-observer>
              </v-card-text>
              <template v-if="importErrors.length > 0">
                <v-card-title>処理結果</v-card-title>
                <v-divider />
                <v-card-text>
                  <error-messages :error-messages="importErrors" />
                </v-card-text>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ErrorMessages from '../../../components/errors/_Message'
import DownloadMixin from '../../../../mixins/download-mixin'
import { mapActions } from 'vuex'

export default {
  name: 'SettingEmissionLocation',
  components: {
    ErrorMessages,
  },
  mixins: [
    DownloadMixin
  ],
  props: {},
  data() {
    return {
      file: null,
      importErrors: [],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    ...mapActions('DriverSettingEmissionLocation', {
      download: 'index',
      upload: 'create',
    }),
    downloadButtonClickEvent () {
      this.download().then((content) => {
        this.downloadCsv(content, '排出事業場')
      })
    },
    uploadButtonClickEvent () {
      const params = new FormData()
      params.append('file', this.file)

      /**
       * @typedef content { Object }
       * @property has_error { Boolean }
       * @property errors { Array }
       */
      this.upload({params: params}).then((content) => {
        if (content.has_error) {
          this.importErrors = content.errors
        } else {
          this.importErrors = []
        }
      })
    },
  }
}
</script>
